<template>
  <div v-if="image" class="aspect-square shrink-0 overflow-hidden rounded-md" style="width: 15%">
    <img class="block h-full w-full object-cover" :src="image" />
  </div>
  <div
    class="flex flex-shrink flex-col gap-1 text-xs"
    style="color: #48454e"
    :style="{ width: `calc(100%${image ? ' - 13.2%' : ''} - 15.2%)` }"
  >
    <div class="flex w-full flex-shrink flex-grow" style="gap: 2%">
      <span class="flex-shrink truncate font-semibold" style="color: #1c1b1f">{{
        title || "Recurly Engage"
      }}</span
      ><span>•</span><span>5m</span>
    </div>
    <div class="truncate">{{ message || "⠀" }}</div>
  </div>
  <div class="flex-grow" style="min-height: 15%"></div>
  <div class="inline-flex aspect-square shrink-0" style="width: 10%">
    <div class="mr-0 ml-auto inline-flex" style="width: 50%">
      <RfChevronIcon
        class="m-auto h-full! w-full! translate-x-0 translate-y-0 -rotate-90 fill-[#1C1B1F]!"
      />
    </div>
  </div>
</template>

<script setup>
import RfChevronIcon from "@/components/icons/RfChevronIcon.vue";

defineProps({
  title: { type: String, default: "Title" },
  message: { type: String, default: "Message" },
  image: { type: String, default: "" },
});
</script>
